module.exports = __webpack_public_path__ + "static/bg1-46bee259ad69e22c4ce5a333e911d780.jpg";